import { PlainButton } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { ReactComponent as BackIcon } from "./assets/back.svg";

export const CXAdminTopbar = () => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();
  const handleBack = () => navigateToPage("clientSupport");

  return (
    <div className="border-dark-200 text-dark flex h-[60px] items-center gap-2 border-x-0 border-b border-t-0 border-solid bg-white px-2.5">
      <PlainButton
        onClick={handleBack}
        className="text-dark flex items-center justify-center rounded-md p-2.5 transition-colors hover:bg-[#F9F9F9]"
      >
        <BackIcon />
      </PlainButton>
      <span className="font-secondary text-lg font-medium">
        {t({
          id: "cx-admin-sidebar.title",
          defaultMessage: "Workspace Settings",
        })}
      </span>
    </div>
  );
};
